/**
 * Utils for optimizing JSON array payloads into 2D arrays due to Lambda size restrictions.
 * Keep api/wartsila-online-lib/src/flatten.ts and client/src/util/flatten.ts in sync!
 */

export interface IFlattenedData {
  headers: string[]; // Represents the column names or keys
  rows: string[][]; // Represents the 2D array of data values
}

export const flatten = (objects: any[]): IFlattenedData => {
  const flattenedData: IFlattenedData = {
    headers: [],
    rows: [],
  };

  if (objects && objects.length > 0) {
    const normalizedObjects = normalizeObjects(objects);
    flattenedData.rows = normalizedObjects.map((obj) => Object.values(obj));
    flattenedData.headers = Object.keys(normalizedObjects[0]);
  }

  return flattenedData;
};

const normalizeObjects = (objects: any[]): any[] => {
  const allKeys = new Set<string>();
  objects.forEach((item) => {
    Object.keys(item).forEach((key) => allKeys.add(key));
  });

  const sortedKeys = Array.from(allKeys).sort();

  return objects.map((object) => {
    const normalizedObject: any = {};
    sortedKeys.forEach((key) => {
      normalizedObject[key] = object[key] ?? null;
    });
    return normalizedObject;
  });
};

export const unflatten = <T>(flattenedData: IFlattenedData): T[] => {
  if (flattenedData && flattenedData.rows) {
    return flattenedData.rows.map((arr) => {
      const obj: any = {};
      flattenedData.headers.forEach((key, index) => {
        obj[key] = arr[index];
      });
      return obj as T;
    });
  }
  return [];
};
